<script>
export default {
    name: "IconZoomGlass"
}
</script>

<template>
    <svg class="w-20 h-20 text-gray-800" aria-hidden="true"
         xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
              d="m21 21-3.5-3.5M10 7v6m-3-3h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
